// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__3DRzi","pag_elem":"pagination_pag_elem__2-XYw","active":"pagination_active__Z4XW3"};